module.exports = __webpack_public_path__ + "res/img_business_bg.61b60a9c65fc4f66bc82468103b44ea3.png";